import React, { useId } from 'react'
import PropTypes from 'prop-types'

const EyesIcon = React.forwardRef(function EyesIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M6 6C2.69 6 0 8.69 0 12 0 15.31 2.69 18 6 18 9.31 18 12 15.31 12 12 12 8.69 9.31 6 6 6ZM6 16C3.93 16 2.25 14.42 2.04 12.4 2.23 13.31 3.03 14 4 14 5.1 14 6 13.1 6 12 6 10.9 5.1 10 4 10 3.03 10 2.23 10.69 2.04 11.6 2.25 9.58 3.93 8 6 8 8.21 8 10 9.79 10 12 10 14.21 8.21 16 6 16ZM18 6C14.69 6 12 8.69 12 12 12 15.31 14.69 18 18 18 21.31 18 24 15.31 24 12 24 8.69 21.31 6 18 6ZM18 16C15.93 16 14.25 14.42 14.04 12.4 14.23 13.31 15.03 14 16 14 17.1 14 18 13.1 18 12 18 10.9 17.1 10 16 10 15.03 10 14.23 10.69 14.04 11.6 14.25 9.58 15.93 8 18 8 20.21 8 22 9.79 22 12 22 14.21 20.21 16 18 16ZM15.7 2.72C15.73 2.69 16.48 2 18 2 19.52 2 20.27 2.69 20.29 2.71 20.49 2.9 20.74 3 21 3 21.26 3 21.51 2.9 21.71 2.71 22.1 2.32 22.1 1.69 21.71 1.3 21.57 1.16 20.35 0 18 0 15.65 0 14.43 1.16 14.29 1.29 13.9 1.68 13.91 2.29 14.28 2.69 14.67 3.08 15.3 3.09 15.7 2.72ZM3.7 2.72C3.73 2.69 4.48 2 6 2 7.52 2 8.27 2.69 8.29 2.71 8.49 2.9 8.74 3 9 3 9.26 3 9.51 2.9 9.71 2.71 10.1 2.32 10.1 1.69 9.71 1.3 9.57 1.16 8.35 0 6 0 3.65 0 2.43 1.16 2.29 1.29 1.9 1.68 1.91 2.29 2.28 2.69 2.67 3.08 3.3 3.09 3.7 2.72Z"></path>
    </svg>
  )
})

EyesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

EyesIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default EyesIcon
